/**
 * This is a spinning wheel that can be displayed to indicate that 
 * something is happening and the user has to wait.
 */
class ProgressIndicator {
	constructor(el) {
		this.progressIndicator = null;
		this.positionRelative = false;
		this.el = el;
	}

	showProgressIndicator(positionRelative = false, cssRuleForAlignEl = "div", searchCssRuleDown = false) {
		if (!this.progressIndicator) {
			this.progressIndicator = document.createElement('div');
			this.progressIndicator.className = 'progressIndicatorDiv';

			const progImg = document.createElement('img');
			progImg.src = '/static-images/shared/shared/tng/progress.gif';
			progImg.className = 'progressIndicator';

			this.progressIndicator.appendChild(progImg);

			if (positionRelative) {
				this.positionRelative = true;
			} else {
				legacyGlobal.getToplevelElement().appendChild(this.progressIndicator);
				this.positionRelative = false;
			}
		}

		if(!cssRuleForAlignEl) {
			cssRuleForAlignEl = "div";
		}

		let alignEl = this.el ?
			(searchCssRuleDown
				? this.el.querySelector(cssRuleForAlignEl)
				: this.el.closest(cssRuleForAlignEl)) : null;

		alignEl = alignEl || this.el;

		const masterDims = { width: alignEl.offsetWidth, height: alignEl.offsetHeight };
		if (this.positionRelative) {
			alignEl.style.position = 'relative';
			alignEl.appendChild(this.progressIndicator);
			this.progressIndicator.style.left = 0;
			this.progressIndicator.style.top = 0;
			this.progressIndicator.style.width = '100%';
			this.progressIndicator.style.height = '100%';
			this.progressIndicator.style.minHeight = 'inherit';
		} else {
			const masterPos = alignEl.getBoundingClientRect();
			this.progressIndicator.style.left = masterPos.left + 'px';
			this.progressIndicator.style.top = masterPos.top + 'px';
			this.progressIndicator.style.width = masterDims.width + 'px';
			this.progressIndicator.style.height = masterDims.height + 'px';
		}
		this.progressIndicator.style.display = '';
		this.progressIndicator.style.position = 'absolute';
		this.progressIndicator.style.zIndex = '900';
		this.progressIndicator.style.opacity = .5;
	}

	hideProgressIndicator() {
		if (this.progressIndicator) {
			this.progressIndicator.style.display = 'none';
		}
	}
}
